import { parsePhoneNumberFromString } from 'libphonenumber-js';

const forbiddenKeywords = [
  'whatsapp', 'wtapp', 'wtsapp', 'watsapp', 'whats app',
  'phone', 'ph', 'mob', 'mobile', 'cell',
  'mail', 'email', 'e-mail',
  'instagram', 'insta', 'ig',
  'facebook', 'fb', 'face book',
  'telegram', 'tg',
  'snapchat', 'sc',
  'twitter', 'tw',
  'linkedin', 'li',
  'contact', 'connect',
  'wechat', 'line', 'signal',
  'viber', 'kik', 'discord', 'ds',
  'message'
];

const forbiddenKeywordsRegex = new RegExp(`\\b(${forbiddenKeywords.join('|')})\\b`, 'gi');
const emailRegex = /\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/gi;

const numberWords = [
  'zero', 'oh', 'one', 'two', 'three', 'four', 'five',
  'six', 'seven', 'eight', 'nine', 'ten', 'eleven', 'twelve',
  'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen',
  'eighteen', 'nineteen', 'twenty', 'thirty', 'forty', 'fifty',
  'sixty', 'seventy', 'eighty', 'ninety', 'hundred', 'thousand'
];
const numberWordsRegex = new RegExp(`\\b(?:${numberWords.join('|')})(?:[\\s\\-]+(?:${numberWords.join('|')}))*\\b`, 'gi');

const romanNumeralsRegex = /\b[IVXLCDM]{2,}\b/gi;
const localDigitsRegex = /[\u0660-\u0669\u06F0-\u06F9\u0966-\u096F\u09E6-\u09EF\u0BE6-\u0BEF\u0C66-\u0C6F\u0CE6-\u0CEF\u0D66-\u0D6F\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F29\u1040-\u1049\u10F0-\u10F9]+/g;

// Check if a string has 5+ digits (ignoring symbols)
function hasEnoughDigits(str, min = 5) {
  const digits = str.replace(/\D/g, ''); // remove non-digits
  return digits.length >= min;
}

// Try parsing as phone number
function isPhoneNumber(str) {
  const cleaned = str.replace(/[^\d+]/g, '');
  try {
    const phone = parsePhoneNumberFromString(cleaned);
    return phone?.isValid?.() ?? false;
  } catch {
    return false;
  }
}

// Detect if string contains any contact info
export function containsForbiddenContactInfo(text) {
  if (!text || typeof text !== 'string') return false;

  const lower = text.toLowerCase();

  if (forbiddenKeywordsRegex.test(lower)) return true;
  if (emailRegex.test(text)) return true;
  if (numberWordsRegex.test(lower)) return true;
  if (romanNumeralsRegex.test(text)) return true;
  if (localDigitsRegex.test(text)) return true;

  // Check digit-like sequences
  const digitPattern = /[+\d\s\-().]{5,}/g;
  const matches = text.match(digitPattern);
  if (matches) {
    for (const match of matches) {
      if (hasEnoughDigits(match)) {
        if (isPhoneNumber(match) || match.replace(/\D/g, '').length >= 5) return true;
      }
    }
  }

  return false;
}

// Remove forbidden info from text
export function cleanForbiddenContactInfo(text) {
  if (!text || typeof text !== 'string') return text;

  let cleaned = text;

  cleaned = cleaned.replace(forbiddenKeywordsRegex, '');
  cleaned = cleaned.replace(emailRegex, '');
  cleaned = cleaned.replace(numberWordsRegex, '');
  cleaned = cleaned.replace(romanNumeralsRegex, '');
  cleaned = cleaned.replace(localDigitsRegex, '');

  // Remove all digit-like patterns with 5+ digits
  cleaned = cleaned.replace(/[+\d\s\-().]{5,}/g, (match) => {
    if (hasEnoughDigits(match) && (isPhoneNumber(match) || match.replace(/\D/g, '').length >= 5)) {
      return '';
    }
    return match;
  });

  // Cleanup extra whitespace
  return cleaned.replace(/\s{2,}/g, ' ').trim();
}
